module.exports = __webpack_public_path__ + "static/img/hover-iocn48.f0c7509.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add_icon/hover-iocn48.png
// module id = 9gLG
// module chunks = 1